[
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 123001.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123001",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-01T15:00:00",
		"Date_of_Extraction": "2021-08-01T15:00:00",
		"Date_of_Analysis": "2021-08-01T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "Chargen-Nr.: 66816",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.030746,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 321.0,
		"woF_15_25": 117.0,
		"woF_25_50": 106.0,
		"woF_50_100": 47.0,
		"woF_100_150": 9.0,
		"woF_150_200": 0.0,
		"woF_200_400": 3.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 321.0,
		"All_15_25": 117.0,
		"All_25_50": 106.0,
		"All_50_100": 47.0,
		"All_100_150": 9.0,
		"All_150_200": 3.0,
		"All_200_400": 5.0,
		"All_400_600": 5.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 8.0,
		"All_300_400": 3.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 1.0,
		"Met_25_50": 4.0,
		"Met_50_100": 4.0,
		"Met_100_150": 2.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 351.0,
		"woFNM_1W": 283.0,
		"woFNM_2L": 329.0,
		"woFNM_2W": 92.0,
		"woFNM_3L": 281.0,
		"woFNM_3W": 65.0,
		"woFNM_4L": 144.0,
		"woFNM_4W": 56.0,
		"woFNM_5L": 139.0,
		"woFNM_5W": 49.0,
		"Met_1L": 118.0,
		"Met_1W": 51.0,
		"Met_2L": 106.0,
		"Met_2W": 16.0,
		"Met_3L": 66.0,
		"Met_3W": 22.0,
		"Met_4L": 61.0,
		"Met_4W": 22.0,
		"Met_5L": 60.0,
		"Met_5W": 27.0,
		"Fib_Fmax1_Fmax": 1445.0,
		"Fib_Fmax1_Lstr": 1638.0,
		"Fib_Fmax2_Fmax": 886.0,
		"Fib_Fmax2_Lstr": 953.0,
		"Fib_Lstr1_Fmax": 1445.0,
		"Fib_Lstr1_Lstr": 1638.0,
		"Fib_Fmax_Sum_um": 6709.0,
		"Fib_Stretched_Sum_um": 7394.0,
		"woF_weighted_sum": 131.0,
		"All_weighted_sum": 1198.0,
		"Met_weighted_sum": 12.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123001,
		"ioResult": true,
		"met_sum": 6.0,
		"nm_sum": 53.0,
		"fibers_sum": 13.0,
		"sum_fibers": 13.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 123002,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123002",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.04,
		"Date_of_arrival": "2021-08-02T15:00:00",
		"Date_of_Extraction": "2021-08-02T15:00:00",
		"Date_of_Analysis": "2021-08-02T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1234",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.032,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 213.0,
		"woF_15_25": 102.0,
		"woF_25_50": 132.0,
		"woF_50_100": 78.0,
		"woF_100_150": 10.0,
		"woF_150_200": 1.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 213.0,
		"All_15_25": 102.0,
		"All_25_50": 132.0,
		"All_50_100": 78.0,
		"All_100_150": 12.0,
		"All_150_200": 2.0,
		"All_200_400": 6.0,
		"All_400_600": 1.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 2.0,
		"All_200_300": 7.0,
		"All_300_400": 6.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 3.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 0.0,
		"Met_15_25": 1.0,
		"Met_25_50": 2.0,
		"Met_50_100": 5.0,
		"Met_100_150": 2.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 204.0,
		"woFNM_1W": 46.0,
		"woFNM_2L": 162.0,
		"woFNM_2W": 113.0,
		"woFNM_3L": 141.0,
		"woFNM_3W": 101.0,
		"woFNM_4L": 129.0,
		"woFNM_4W": 54.0,
		"woFNM_5L": 116.0,
		"woFNM_5W": 46.0,
		"Met_1L": 131.0,
		"Met_1W": 22.0,
		"Met_2L": 111.0,
		"Met_2W": 61.0,
		"Met_3L": 95.0,
		"Met_3W": 38.0,
		"Met_4L": 73.0,
		"Met_4W": 19.0,
		"Met_5L": 72.0,
		"Met_5W": 59.0,
		"Fib_Fmax1_Fmax": 1283.0,
		"Fib_Fmax1_Lstr": 1739.0,
		"Fib_Fmax2_Fmax": 1031.0,
		"Fib_Fmax2_Lstr": 1318.0,
		"Fib_Lstr1_Fmax": 1283.0,
		"Fib_Lstr1_Lstr": 1739.0,
		"Fib_Fmax_Sum_um": 7703.0,
		"Fib_Stretched_Sum_um": 9187.0,
		"woF_weighted_sum": 143.0,
		"All_weighted_sum": 1680.0,
		"Met_weighted_sum": 13.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123002,
		"ioResult": false,
		"met_sum": 7.0,
		"nm_sum": 83.0,
		"fibers_sum": 15.0,
		"sum_fibers": 15.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 123003,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123003",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.06,
		"Date_of_arrival": "2021-08-03T15:00:00",
		"Date_of_Extraction": "2021-08-03T15:00:00",
		"Date_of_Analysis": "2021-08-03T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "nach Waschen / 14.05.2018",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,3 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.007786,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 165.0,
		"woF_15_25": 65.0,
		"woF_25_50": 84.0,
		"woF_50_100": 18.0,
		"woF_100_150": 1.0,
		"woF_150_200": 0.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 165.0,
		"All_15_25": 65.0,
		"All_25_50": 84.0,
		"All_50_100": 18.0,
		"All_100_150": 1.0,
		"All_150_200": 0.0,
		"All_200_400": 0.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 0.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 3.0,
		"Met_25_50": 12.0,
		"Met_50_100": 7.0,
		"Met_100_150": 1.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 68.0,
		"woFNM_1W": 38.0,
		"woFNM_2L": 65.0,
		"woFNM_2W": 21.0,
		"woFNM_3L": 65.0,
		"woFNM_3W": 45.0,
		"woFNM_4L": 63.0,
		"woFNM_4W": 39.0,
		"woFNM_5L": 62.0,
		"woFNM_5W": 43.0,
		"Met_1L": 110.0,
		"Met_1W": 59.0,
		"Met_2L": 74.0,
		"Met_2W": 45.0,
		"Met_3L": 70.0,
		"Met_3W": 21.0,
		"Met_4L": 68.0,
		"Met_4W": 37.0,
		"Met_5L": 68.0,
		"Met_5W": 16.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 22.0,
		"All_weighted_sum": 22.0,
		"Met_weighted_sum": 11.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123003,
		"ioResult": false,
		"met_sum": 8.0,
		"nm_sum": 11.0,
		"fibers_sum": 0.0,
		"sum_fibers": 0.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 123004,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123004",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-04T15:00:00",
		"Date_of_Extraction": "2021-08-04T15:00:00",
		"Date_of_Analysis": "2021-08-04T15:00:00",
		"Component": "Flusscheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "nach Waschen",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.014039,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 279.0,
		"woF_15_25": 74.0,
		"woF_25_50": 59.0,
		"woF_50_100": 28.0,
		"woF_100_150": 3.0,
		"woF_150_200": 2.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 279.0,
		"All_15_25": 74.0,
		"All_25_50": 59.0,
		"All_50_100": 28.0,
		"All_100_150": 3.0,
		"All_150_200": 2.0,
		"All_200_400": 2.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 1.0,
		"All_200_300": 1.0,
		"All_300_400": 1.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 1.0,
		"Met_25_50": 1.0,
		"Met_50_100": 4.0,
		"Met_100_150": 2.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 327.0,
		"woFNM_1W": 132.0,
		"woFNM_2L": 184.0,
		"woFNM_2W": 87.0,
		"woFNM_3L": 153.0,
		"woFNM_3W": 86.0,
		"woFNM_4L": 105.0,
		"woFNM_4W": 70.0,
		"woFNM_5L": 87.0,
		"woFNM_5W": 70.0,
		"Met_1L": 128.0,
		"Met_1W": 21.0,
		"Met_2L": 111.0,
		"Met_2W": 27.0,
		"Met_3L": 98.0,
		"Met_3W": 43.0,
		"Met_4L": 82.0,
		"Met_4W": 54.0,
		"Met_5L": 73.0,
		"Met_5W": 59.0,
		"Fib_Fmax1_Fmax": 1520.0,
		"Fib_Fmax1_Lstr": 1642.0,
		"Fib_Fmax2_Fmax": 376.0,
		"Fib_Fmax2_Lstr": 382.0,
		"Fib_Lstr1_Fmax": 1520.0,
		"Fib_Lstr1_Lstr": 1642.0,
		"Fib_Fmax_Sum_um": 1896.0,
		"Fib_Stretched_Sum_um": 2024.0,
		"woF_weighted_sum": 74.0,
		"All_weighted_sum": 490.0,
		"Met_weighted_sum": 12.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123004,
		"ioResult": true,
		"met_sum": 6.0,
		"nm_sum": 28.0,
		"fibers_sum": 2.0,
		"sum_fibers": 2.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 67524.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123005",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-05T15:00:00",
		"Date_of_Extraction": "2021-08-05T15:00:00",
		"Date_of_Analysis": "2021-08-05T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "Scheibe gewaschen (Henze)",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,3 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.052456,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 324.0,
		"woF_15_25": 206.0,
		"woF_25_50": 411.0,
		"woF_50_100": 146.0,
		"woF_100_150": 13.0,
		"woF_150_200": 2.0,
		"woF_200_400": 4.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 324.0,
		"All_15_25": 206.0,
		"All_25_50": 411.0,
		"All_50_100": 146.0,
		"All_100_150": 13.0,
		"All_150_200": 3.0,
		"All_200_400": 7.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 1.0,
		"All_200_300": 1.0,
		"All_300_400": 1.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 4.0,
		"Met_15_25": 3.0,
		"Met_25_50": 10.0,
		"Met_50_100": 18.0,
		"Met_100_150": 5.0,
		"Met_150_200": 1.0,
		"Met_200_400": 3.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 362.0,
		"woFNM_1W": 85.0,
		"woFNM_2L": 195.0,
		"woFNM_2W": 43.0,
		"woFNM_3L": 144.0,
		"woFNM_3W": 21.0,
		"woFNM_4L": 137.0,
		"woFNM_4W": 53.0,
		"woFNM_5L": 129.0,
		"woFNM_5W": 76.0,
		"Met_1L": 254.0,
		"Met_1W": 59.0,
		"Met_2L": 246.0,
		"Met_2W": 123.0,
		"Met_3L": 237.0,
		"Met_3W": 123.0,
		"Met_4L": 158.0,
		"Met_4W": 128.0,
		"Met_5L": 112.0,
		"Met_5W": 69.0,
		"Fib_Fmax1_Fmax": 1312.0,
		"Fib_Fmax1_Lstr": 1506.0,
		"Fib_Fmax2_Fmax": 277.0,
		"Fib_Fmax2_Lstr": 379.0,
		"Fib_Lstr1_Fmax": 1312.0,
		"Fib_Lstr1_Lstr": 1506.0,
		"Fib_Fmax_Sum_um": 2173.0,
		"Fib_Stretched_Sum_um": 2662.0,
		"woF_weighted_sum": 280.0,
		"All_weighted_sum": 737.0,
		"Met_weighted_sum": 95.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123005,
		"ioResult": false,
		"met_sum": 27.0,
		"nm_sum": 138.0,
		"fibers_sum": 5.0,
		"sum_fibers": 5.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 50028.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123006",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-06T15:00:00",
		"Date_of_Extraction": "2021-08-06T15:00:00",
		"Date_of_Analysis": "2021-08-06T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "Gleitgeschliffen und gewaschen. Sch\u00c3\u00bcttgutverpackt.",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.03824,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 362.0,
		"woF_15_25": 164.0,
		"woF_25_50": 231.0,
		"woF_50_100": 131.0,
		"woF_100_150": 14.0,
		"woF_150_200": 1.0,
		"woF_200_400": 4.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 362.0,
		"All_15_25": 164.0,
		"All_25_50": 231.0,
		"All_50_100": 131.0,
		"All_100_150": 14.0,
		"All_150_200": 1.0,
		"All_200_400": 5.0,
		"All_400_600": 1.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 0.0,
		"All_200_300": 2.0,
		"All_300_400": 1.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 1.0,
		"Met_25_50": 6.0,
		"Met_50_100": 9.0,
		"Met_100_150": 6.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 312.0,
		"woFNM_1W": 133.0,
		"woFNM_2L": 231.0,
		"woFNM_2W": 66.0,
		"woFNM_3L": 226.0,
		"woFNM_3W": 59.0,
		"woFNM_4L": 220.0,
		"woFNM_4W": 100.0,
		"woFNM_5L": 194.0,
		"woFNM_5W": 81.0,
		"Met_1L": 142.0,
		"Met_1W": 64.0,
		"Met_2L": 128.0,
		"Met_2W": 58.0,
		"Met_3L": 123.0,
		"Met_3W": 48.0,
		"Met_4L": 123.0,
		"Met_4W": 72.0,
		"Met_5L": 116.0,
		"Met_5W": 22.0,
		"Fib_Fmax1_Fmax": 768.0,
		"Fib_Fmax1_Lstr": 813.0,
		"Fib_Fmax2_Fmax": 477.0,
		"Fib_Fmax2_Lstr": 761.0,
		"Fib_Lstr1_Fmax": 768.0,
		"Fib_Lstr1_Lstr": 813.0,
		"Fib_Fmax_Sum_um": 1560.0,
		"Fib_Stretched_Sum_um": 1901.0,
		"woF_weighted_sum": 260.0,
		"All_weighted_sum": 484.0,
		"Met_weighted_sum": 33.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123006,
		"Passed": "1",
		"met_sum": 15.0,
		"nm_sum": 135.0,
		"fibers_sum": 3.0,
		"sum_fibers": 3.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 50027.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123007",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.05,
		"Date_of_arrival": "2021-08-07T15:00:00",
		"Date_of_Extraction": "2021-08-07T15:00:00",
		"Date_of_Analysis": "2021-08-07T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "10 Stk. Gleitgeschliffen und gewaschen. Sch\u00c3\u00bcttgutverpackt.",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.05846,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 320.0,
		"woF_15_25": 172.0,
		"woF_25_50": 309.0,
		"woF_50_100": 141.0,
		"woF_100_150": 19.0,
		"woF_150_200": 7.0,
		"woF_200_400": 4.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 320.0,
		"All_15_25": 172.0,
		"All_25_50": 309.0,
		"All_50_100": 141.0,
		"All_100_150": 19.0,
		"All_150_200": 7.0,
		"All_200_400": 9.0,
		"All_400_600": 1.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 0.0,
		"All_200_300": 3.0,
		"All_300_400": 2.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 4.0,
		"Met_25_50": 7.0,
		"Met_50_100": 18.0,
		"Met_100_150": 6.0,
		"Met_150_200": 5.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 390.0,
		"woFNM_1W": 322.0,
		"woFNM_2L": 286.0,
		"woFNM_2W": 73.0,
		"woFNM_3L": 245.0,
		"woFNM_3W": 102.0,
		"woFNM_4L": 224.0,
		"woFNM_4W": 75.0,
		"woFNM_5L": 166.0,
		"woFNM_5W": 21.0,
		"Met_1L": 194.0,
		"Met_1W": 97.0,
		"Met_2L": 192.0,
		"Met_2W": 118.0,
		"Met_3L": 186.0,
		"Met_3W": 86.0,
		"Met_4L": 181.0,
		"Met_4W": 72.0,
		"Met_5L": 152.0,
		"Met_5W": 70.0,
		"Fib_Fmax1_Fmax": 853.0,
		"Fib_Fmax1_Lstr": 1006.0,
		"Fib_Fmax2_Fmax": 617.0,
		"Fib_Fmax2_Lstr": 648.0,
		"Fib_Lstr1_Fmax": 853.0,
		"Fib_Lstr1_Lstr": 1006.0,
		"Fib_Fmax_Sum_um": 3563.0,
		"Fib_Stretched_Sum_um": 4356.0,
		"woF_weighted_sum": 344.0,
		"All_weighted_sum": 776.0,
		"Met_weighted_sum": 87.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123007,
		"Passed": "1",
		"met_sum": 29.0,
		"nm_sum": 142.0,
		"fibers_sum": 8.0,
		"sum_fibers": 8.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 50026.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123008",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.14,
		"Date_of_arrival": "2021-08-08T15:00:00",
		"Date_of_Extraction": "2021-08-08T15:00:00",
		"Date_of_Analysis": "2021-08-08T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "10 Stk. Gleitgeschliffen. Nicht gewaschen.",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.121658,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 537.0,
		"woF_15_25": 561.0,
		"woF_25_50": 801.0,
		"woF_50_100": 369.0,
		"woF_100_150": 51.0,
		"woF_150_200": 3.0,
		"woF_200_400": 2.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 537.0,
		"All_15_25": 561.0,
		"All_25_50": 801.0,
		"All_50_100": 369.0,
		"All_100_150": 51.0,
		"All_150_200": 4.0,
		"All_200_400": 3.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 0.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 2.0,
		"Met_25_50": 9.0,
		"Met_50_100": 20.0,
		"Met_100_150": 7.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 238.0,
		"woFNM_1W": 42.0,
		"woFNM_2L": 203.0,
		"woFNM_2W": 48.0,
		"woFNM_3L": 162.0,
		"woFNM_3W": 54.0,
		"woFNM_4L": 162.0,
		"woFNM_4W": 87.0,
		"woFNM_5L": 148.0,
		"woFNM_5W": 64.0,
		"Met_1L": 168.0,
		"Met_1W": 59.0,
		"Met_2L": 146.0,
		"Met_2W": 68.0,
		"Met_3L": 134.0,
		"Met_3W": 78.0,
		"Met_4L": 123.0,
		"Met_4W": 66.0,
		"Met_5L": 121.0,
		"Met_5W": 81.0,
		"Fib_Fmax1_Fmax": 377.0,
		"Fib_Fmax1_Lstr": 389.0,
		"Fib_Fmax2_Fmax": 190.0,
		"Fib_Fmax2_Lstr": 192.0,
		"Fib_Lstr1_Fmax": 377.0,
		"Fib_Lstr1_Lstr": 389.0,
		"Fib_Fmax_Sum_um": 568.0,
		"Fib_Stretched_Sum_um": 581.0,
		"woF_weighted_sum": 632.0,
		"All_weighted_sum": 657.0,
		"Met_weighted_sum": 57.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123008,
		"Passed": "1",
		"met_sum": 28.0,
		"nm_sum": 397.0,
		"fibers_sum": 2.0,
		"sum_fibers": 2.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 50025.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123009",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.05,
		"Date_of_arrival": "2021-08-09T15:00:00",
		"Date_of_Extraction": "2021-08-09T15:00:00",
		"Date_of_Analysis": "2021-08-09T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "10 Stk. Gleitgeschliffen. Nicht gewaschen.",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.118498,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 549.0,
		"woF_15_25": 567.0,
		"woF_25_50": 918.0,
		"woF_50_100": 337.0,
		"woF_100_150": 31.0,
		"woF_150_200": 2.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 549.0,
		"All_15_25": 567.0,
		"All_25_50": 918.0,
		"All_50_100": 337.0,
		"All_100_150": 31.0,
		"All_150_200": 2.0,
		"All_200_400": 3.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 0.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 4.0,
		"Met_25_50": 5.0,
		"Met_50_100": 20.0,
		"Met_100_150": 1.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 187.0,
		"woFNM_1W": 123.0,
		"woFNM_2L": 184.0,
		"woFNM_2W": 91.0,
		"woFNM_3L": 143.0,
		"woFNM_3W": 97.0,
		"woFNM_4L": 137.0,
		"woFNM_4W": 91.0,
		"woFNM_5L": 136.0,
		"woFNM_5W": 124.0,
		"Met_1L": 100.0,
		"Met_1W": 21.0,
		"Met_2L": 98.0,
		"Met_2W": 54.0,
		"Met_3L": 97.0,
		"Met_3W": 32.0,
		"Met_4L": 96.0,
		"Met_4W": 43.0,
		"Met_5L": 96.0,
		"Met_5W": 48.0,
		"Fib_Fmax1_Fmax": 371.0,
		"Fib_Fmax1_Lstr": 426.0,
		"Fib_Fmax2_Fmax": 288.0,
		"Fib_Fmax2_Lstr": 311.0,
		"Fib_Lstr1_Fmax": 371.0,
		"Fib_Lstr1_Lstr": 426.0,
		"Fib_Fmax_Sum_um": 916.0,
		"Fib_Stretched_Sum_um": 1003.0,
		"woF_weighted_sum": 479.0,
		"All_weighted_sum": 527.0,
		"Met_weighted_sum": 24.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123009,
		"Passed": "1",
		"met_sum": 21.0,
		"nm_sum": 349.0,
		"fibers_sum": 3.0,
		"sum_fibers": 3.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 50024.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123010",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.04,
		"Date_of_arrival": "2021-08-10T15:00:00",
		"Date_of_Extraction": "2021-08-10T15:00:00",
		"Date_of_Analysis": "2021-08-10T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "Gewaschen",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.03483,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 301.0,
		"woF_15_25": 126.0,
		"woF_25_50": 164.0,
		"woF_50_100": 67.0,
		"woF_100_150": 12.0,
		"woF_150_200": 6.0,
		"woF_200_400": 2.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 301.0,
		"All_15_25": 126.0,
		"All_25_50": 164.0,
		"All_50_100": 67.0,
		"All_100_150": 13.0,
		"All_150_200": 6.0,
		"All_200_400": 5.0,
		"All_400_600": 1.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 0.0,
		"All_200_300": 3.0,
		"All_300_400": 2.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 4.0,
		"Met_25_50": 4.0,
		"Met_50_100": 13.0,
		"Met_100_150": 5.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 287.0,
		"woFNM_1W": 27.0,
		"woFNM_2L": 269.0,
		"woFNM_2W": 107.0,
		"woFNM_3L": 195.0,
		"woFNM_3W": 118.0,
		"woFNM_4L": 170.0,
		"woFNM_4W": 32.0,
		"woFNM_5L": 164.0,
		"woFNM_5W": 73.0,
		"Met_1L": 157.0,
		"Met_1W": 91.0,
		"Met_2L": 125.0,
		"Met_2W": 75.0,
		"Met_3L": 121.0,
		"Met_3W": 77.0,
		"Met_4L": 108.0,
		"Met_4W": 64.0,
		"Met_5L": 106.0,
		"Met_5W": 58.0,
		"Fib_Fmax1_Fmax": 948.0,
		"Fib_Fmax1_Lstr": 1347.0,
		"Fib_Fmax2_Fmax": 932.0,
		"Fib_Fmax2_Lstr": 1000.0,
		"Fib_Lstr1_Fmax": 948.0,
		"Fib_Lstr1_Lstr": 1347.0,
		"Fib_Fmax_Sum_um": 3545.0,
		"Fib_Stretched_Sum_um": 4734.0,
		"woF_weighted_sum": 201.0,
		"All_weighted_sum": 605.0,
		"Met_weighted_sum": 42.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123010,
		"Passed": "1",
		"met_sum": 19.0,
		"nm_sum": 68.0,
		"fibers_sum": 7.0,
		"sum_fibers": 7.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 50023.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123011",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-11T15:00:00",
		"Date_of_Extraction": "2021-08-11T15:00:00",
		"Date_of_Analysis": "2021-08-11T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "Gewaschen",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.02213,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 276.0,
		"woF_15_25": 124.0,
		"woF_25_50": 136.0,
		"woF_50_100": 54.0,
		"woF_100_150": 6.0,
		"woF_150_200": 1.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 276.0,
		"All_15_25": 124.0,
		"All_25_50": 136.0,
		"All_50_100": 54.0,
		"All_100_150": 6.0,
		"All_150_200": 1.0,
		"All_200_400": 0.0,
		"All_400_600": 0.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 0.0,
		"All_200_300": 1.0,
		"All_300_400": 1.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 4.0,
		"Met_15_25": 4.0,
		"Met_25_50": 3.0,
		"Met_50_100": 7.0,
		"Met_100_150": 3.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 168.0,
		"woFNM_1W": 109.0,
		"woFNM_2L": 131.0,
		"woFNM_2W": 64.0,
		"woFNM_3L": 121.0,
		"woFNM_3W": 64.0,
		"woFNM_4L": 108.0,
		"woFNM_4W": 61.0,
		"woFNM_5L": 99.0,
		"woFNM_5W": 68.0,
		"Met_1L": 115.0,
		"Met_1W": 81.0,
		"Met_2L": 109.0,
		"Met_2W": 91.0,
		"Met_3L": 106.0,
		"Met_3W": 43.0,
		"Met_4L": 96.0,
		"Met_4W": 59.0,
		"Met_5L": 81.0,
		"Met_5W": 54.0,
		"Fib_Fmax1_Fmax": 916.0,
		"Fib_Fmax1_Lstr": 976.0,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": 916.0,
		"Fib_Lstr1_Lstr": 976.0,
		"Fib_Fmax_Sum_um": 916.0,
		"Fib_Stretched_Sum_um": 976.0,
		"woF_weighted_sum": 87.0,
		"All_weighted_sum": 231.0,
		"Met_weighted_sum": 19.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123011,
		"Passed": "1",
		"met_sum": 10.0,
		"nm_sum": 51.0,
		"fibers_sum": 1.0,
		"sum_fibers": 1.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 66385.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123012",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.02,
		"Date_of_arrival": "2021-08-12T15:00:00",
		"Date_of_Extraction": "2021-08-12T15:00:00",
		"Date_of_Analysis": "2021-08-12T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.073766,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 398.0,
		"woF_15_25": 307.0,
		"woF_25_50": 496.0,
		"woF_50_100": 197.0,
		"woF_100_150": 35.0,
		"woF_150_200": 7.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 398.0,
		"All_15_25": 307.0,
		"All_25_50": 496.0,
		"All_50_100": 197.0,
		"All_100_150": 35.0,
		"All_150_200": 7.0,
		"All_200_400": 0.0,
		"All_400_600": 1.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 1.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 0.0,
		"Met_25_50": 7.0,
		"Met_50_100": 20.0,
		"Met_100_150": 7.0,
		"Met_150_200": 2.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 189.0,
		"woFNM_1W": 75.0,
		"woFNM_2L": 179.0,
		"woFNM_2W": 75.0,
		"woFNM_3L": 164.0,
		"woFNM_3W": 39.0,
		"woFNM_4L": 153.0,
		"woFNM_4W": 51.0,
		"woFNM_5L": 151.0,
		"woFNM_5W": 81.0,
		"Met_1L": 162.0,
		"Met_1W": 134.0,
		"Met_2L": 151.0,
		"Met_2W": 129.0,
		"Met_3L": 147.0,
		"Met_3W": 87.0,
		"Met_4L": 142.0,
		"Met_4W": 91.0,
		"Met_5L": 126.0,
		"Met_5W": 64.0,
		"Fib_Fmax1_Fmax": 468.0,
		"Fib_Fmax1_Lstr": 498.0,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": 468.0,
		"Fib_Lstr1_Lstr": 498.0,
		"Fib_Fmax_Sum_um": 468.0,
		"Fib_Stretched_Sum_um": 498.0,
		"woF_weighted_sum": 400.0,
		"All_weighted_sum": 464.0,
		"Met_weighted_sum": 66.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123012,
		"ioResult": false,
		"met_sum": 29.0,
		"nm_sum": 210.0,
		"fibers_sum": 1.0,
		"sum_fibers": 1.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 63182.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123013",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.1,
		"Date_of_arrival": "2021-08-13T15:00:00",
		"Date_of_Extraction": "2021-08-13T15:00:00",
		"Date_of_Analysis": "2021-08-13T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "Gewaschen",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.062311,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 879.0,
		"woF_15_25": 399.0,
		"woF_25_50": 269.0,
		"woF_50_100": 95.0,
		"woF_100_150": 20.0,
		"woF_150_200": 2.0,
		"woF_200_400": 4.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 1.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 879.0,
		"All_15_25": 399.0,
		"All_25_50": 269.0,
		"All_50_100": 95.0,
		"All_100_150": 21.0,
		"All_150_200": 2.0,
		"All_200_400": 5.0,
		"All_400_600": 5.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 3.0,
		"All_200_300": 11.0,
		"All_300_400": 6.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 2.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 9.0,
		"Met_15_25": 13.0,
		"Met_25_50": 11.0,
		"Met_50_100": 18.0,
		"Met_100_150": 7.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 571.0,
		"woFNM_1W": 196.0,
		"woFNM_2L": 375.0,
		"woFNM_2W": 184.0,
		"woFNM_3L": 285.0,
		"woFNM_3W": 162.0,
		"woFNM_4L": 271.0,
		"woFNM_4W": 54.0,
		"woFNM_5L": 227.0,
		"woFNM_5W": 86.0,
		"Met_1L": 159.0,
		"Met_1W": 44.0,
		"Met_2L": 133.0,
		"Met_2W": 38.0,
		"Met_3L": 127.0,
		"Met_3W": 81.0,
		"Met_4L": 127.0,
		"Met_4W": 19.0,
		"Met_5L": 126.0,
		"Met_5W": 49.0,
		"Fib_Fmax1_Fmax": 2264.0,
		"Fib_Fmax1_Lstr": 3962.0,
		"Fib_Fmax2_Fmax": 1855.0,
		"Fib_Fmax2_Lstr": 2746.0,
		"Fib_Lstr1_Fmax": 2264.0,
		"Fib_Lstr1_Lstr": 3962.0,
		"Fib_Fmax_Sum_um": 10028.0,
		"Fib_Stretched_Sum_um": 13664.0,
		"woF_weighted_sum": 321.0,
		"All_weighted_sum": 2229.0,
		"Met_weighted_sum": 55.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123013,
		"ioResult": false,
		"met_sum": 26.0,
		"nm_sum": 96.0,
		"fibers_sum": 11.0,
		"sum_fibers": 11.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 68256.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123014",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.03,
		"Date_of_arrival": "2021-08-14T15:00:00",
		"Date_of_Extraction": "2021-08-14T15:00:00",
		"Date_of_Analysis": "2021-08-14T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.037056,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 166.0,
		"woF_15_25": 66.0,
		"woF_25_50": 101.0,
		"woF_50_100": 69.0,
		"woF_100_150": 12.0,
		"woF_150_200": 3.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 166.0,
		"All_15_25": 66.0,
		"All_25_50": 101.0,
		"All_50_100": 69.0,
		"All_100_150": 12.0,
		"All_150_200": 4.0,
		"All_200_400": 7.0,
		"All_400_600": 2.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 3.0,
		"All_200_300": 9.0,
		"All_300_400": 7.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 3.0,
		"Met_15_25": 3.0,
		"Met_25_50": 1.0,
		"Met_50_100": 26.0,
		"Met_100_150": 5.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 377.0,
		"woFNM_1W": 179.0,
		"woFNM_2L": 156.0,
		"woFNM_2W": 38.0,
		"woFNM_3L": 150.0,
		"woFNM_3W": 92.0,
		"woFNM_4L": 147.0,
		"woFNM_4W": 81.0,
		"woFNM_5L": 121.0,
		"woFNM_5W": 32.0,
		"Met_1L": 165.0,
		"Met_1W": 76.0,
		"Met_2L": 149.0,
		"Met_2W": 56.0,
		"Met_3L": 126.0,
		"Met_3W": 63.0,
		"Met_4L": 119.0,
		"Met_4W": 61.0,
		"Met_5L": 108.0,
		"Met_5W": 27.0,
		"Fib_Fmax1_Fmax": 2001.0,
		"Fib_Fmax1_Lstr": 2256.0,
		"Fib_Fmax2_Fmax": 1195.0,
		"Fib_Fmax2_Lstr": 1286.0,
		"Fib_Lstr1_Fmax": 2001.0,
		"Fib_Lstr1_Lstr": 2256.0,
		"Fib_Fmax_Sum_um": 10147.0,
		"Fib_Stretched_Sum_um": 12001.0,
		"woF_weighted_sum": 160.0,
		"All_weighted_sum": 2169.0,
		"Met_weighted_sum": 55.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123014,
		"ioResult": false,
		"met_sum": 32.0,
		"nm_sum": 53.0,
		"fibers_sum": 15.0,
		"sum_fibers": 15.0,
		"smallest_size_class": "50-100"
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 69787.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123015",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.0,
		"Date_of_arrival": "2021-08-15T15:00:00",
		"Date_of_Extraction": "2021-08-15T15:00:00",
		"Date_of_Analysis": "2021-08-15T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.027248,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 179.0,
		"woF_15_25": 102.0,
		"woF_25_50": 178.0,
		"woF_50_100": 74.0,
		"woF_100_150": 13.0,
		"woF_150_200": 2.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 179.0,
		"All_15_25": 102.0,
		"All_25_50": 178.0,
		"All_50_100": 74.0,
		"All_100_150": 13.0,
		"All_150_200": 2.0,
		"All_200_400": 2.0,
		"All_400_600": 1.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 1.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 4.0,
		"Met_25_50": 5.0,
		"Met_50_100": 22.0,
		"Met_100_150": 4.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 203.0,
		"woFNM_1W": 86.0,
		"woFNM_2L": 190.0,
		"woFNM_2W": 43.0,
		"woFNM_3L": 154.0,
		"woFNM_3W": 48.0,
		"woFNM_4L": 149.0,
		"woFNM_4W": 59.0,
		"woFNM_5L": 137.0,
		"woFNM_5W": 75.0,
		"Met_1L": 126.0,
		"Met_1W": 59.0,
		"Met_2L": 112.0,
		"Met_2W": 58.0,
		"Met_3L": 106.0,
		"Met_3W": 53.0,
		"Met_4L": 101.0,
		"Met_4W": 54.0,
		"Met_5L": 92.0,
		"Met_5W": 54.0,
		"Fib_Fmax1_Fmax": 429.0,
		"Fib_Fmax1_Lstr": 445.0,
		"Fib_Fmax2_Fmax": 393.0,
		"Fib_Fmax2_Lstr": 484.0,
		"Fib_Lstr1_Fmax": 393.0,
		"Fib_Lstr1_Lstr": 484.0,
		"Fib_Fmax_Sum_um": 822.0,
		"Fib_Stretched_Sum_um": 929.0,
		"woF_weighted_sum": 160.0,
		"All_weighted_sum": 240.0,
		"Met_weighted_sum": 38.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123015,
		"Passed": null,
		"met_sum": 26.0,
		"nm_sum": 64.0,
		"fibers_sum": 2.0,
		"sum_fibers": 2.0,
		"smallest_size_class": "50-100",
		"ioResult": true
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 70657.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123016",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.02,
		"Date_of_arrival": "2021-08-16T15:00:00",
		"Date_of_Extraction": "2021-08-16T15:00:00",
		"Date_of_Analysis": "2021-08-16T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "Gewaschen",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.01624,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 1067.0,
		"woF_15_25": 204.0,
		"woF_25_50": 94.0,
		"woF_50_100": 17.0,
		"woF_100_150": 1.0,
		"woF_150_200": 0.0,
		"woF_200_400": 0.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1067.0,
		"All_15_25": 204.0,
		"All_25_50": 94.0,
		"All_50_100": 17.0,
		"All_100_150": 1.0,
		"All_150_200": 0.0,
		"All_200_400": 1.0,
		"All_400_600": 1.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 1.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 15.0,
		"Met_15_25": 21.0,
		"Met_25_50": 11.0,
		"Met_50_100": 3.0,
		"Met_100_150": 0.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 134.0,
		"woFNM_1W": 54.0,
		"woFNM_2L": 89.0,
		"woFNM_2W": 54.0,
		"woFNM_3L": 82.0,
		"woFNM_3W": 49.0,
		"woFNM_4L": 63.0,
		"woFNM_4W": 27.0,
		"woFNM_5L": 62.0,
		"woFNM_5W": 16.0,
		"Met_1L": 69.0,
		"Met_1W": 38.0,
		"Met_2L": 61.0,
		"Met_2W": 16.0,
		"Met_3L": 58.0,
		"Met_3W": 24.0,
		"Met_4L": 47.0,
		"Met_4W": 22.0,
		"Met_5L": 38.0,
		"Met_5W": 22.0,
		"Fib_Fmax1_Fmax": 444.0,
		"Fib_Fmax1_Lstr": 589.0,
		"Fib_Fmax2_Fmax": 282.0,
		"Fib_Fmax2_Lstr": 466.0,
		"Fib_Lstr1_Fmax": 444.0,
		"Fib_Lstr1_Lstr": 589.0,
		"Fib_Fmax_Sum_um": 726.0,
		"Fib_Stretched_Sum_um": 1055.0,
		"woF_weighted_sum": 21.0,
		"All_weighted_sum": 101.0,
		"Met_weighted_sum": 3.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123016,
		"Passed": null,
		"met_sum": 3.0,
		"nm_sum": 15.0,
		"fibers_sum": 2.0,
		"sum_fibers": 2.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	},
	{
		"artsuch": "SCHEIBE",
		"zeichnr": "Scheibe",
		"zeichindex": "1234",
		"betaufnr": 71346.0,
		"kdnr": 12345.0,
		"artnr": "5123432",
		"Analysis_No": "123017",
		"Parts_on_Filter": 10.0,
		"Component_Surface_Area_cm2": null,
		"Weight_mg": 0.03,
		"Date_of_arrival": "2021-08-17T15:00:00",
		"Date_of_Extraction": "2021-08-17T15:00:00",
		"Date_of_Analysis": "2021-08-17T15:00:00",
		"Component": "Scheibe",
		"Component_No": "1 XX",
		"Testing_Specification": "5123432",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.010786,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 129.0,
		"woF_15_25": 50.0,
		"woF_25_50": 60.0,
		"woF_50_100": 23.0,
		"woF_100_150": 5.0,
		"woF_150_200": 0.0,
		"woF_200_400": 1.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 129.0,
		"All_15_25": 50.0,
		"All_25_50": 60.0,
		"All_50_100": 23.0,
		"All_100_150": 5.0,
		"All_150_200": 0.0,
		"All_200_400": 1.0,
		"All_400_600": 0.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 0.0,
		"All_300_400": 0.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 0.0,
		"Met_25_50": 3.0,
		"Met_50_100": 3.0,
		"Met_100_150": 3.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 372.0,
		"woFNM_1W": 222.0,
		"woFNM_2L": 123.0,
		"woFNM_2W": 89.0,
		"woFNM_3L": 114.0,
		"woFNM_3W": 68.0,
		"woFNM_4L": 91.0,
		"woFNM_4W": 38.0,
		"woFNM_5L": 87.0,
		"woFNM_5W": 8.0,
		"Met_1L": 148.0,
		"Met_1W": 21.0,
		"Met_2L": 148.0,
		"Met_2W": 64.0,
		"Met_3L": 104.0,
		"Met_3W": 48.0,
		"Met_4L": 72.0,
		"Met_4W": 43.0,
		"Met_5L": 67.0,
		"Met_5W": 48.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 59.0,
		"All_weighted_sum": 59.0,
		"Met_weighted_sum": 15.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 123017,
		"Passed": null,
		"met_sum": 6.0,
		"nm_sum": 23.0,
		"fibers_sum": 0.0,
		"sum_fibers": 0.0,
		"smallest_size_class": "50-100",
		"ioResult": null
	}
]
